// extracted by mini-css-extract-plugin
export default {"root":"_2wyfKN2s8WLTGRJ9vZar5a","text":"CdcfXixchVXoZRYCnTgV4"};